<template>
  <button type="button" class="btn btn-outline-primary" @click="show = true">Logfile</button>
  <div class="modal" tabindex="-1" :class="show ? 'fade show' : ''" v-show="show">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Logfiles</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="show = false"></button>
        </div>
        <div class="modal-body">
          <div v-for="log in logs" :key="log.id">
            {{ $filters.formatDate(log.created_at) }} - {{ log.user_id[0].first_name }} {{ log.user_id[0].last_name }} {{ log.action }} {{ log.type }}
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-bs-dismiss="modal" @click="show = false">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" v-show="show"></div>
</template>

<script>
export default {
  name: 'ShowLogs',
  props: {
    logs: Object
  },
  data() {
    return {
      show: false,
    }
  }
}
</script>

<style>

</style>
